import { AutoMap } from '@automapper/classes';
import { IsString } from 'class-validator';

export class TimezoneDto {
  @AutoMap()
  @IsString()
  id: string;

  @IsString()
  displayLabel: string;

  @AutoMap()
  @IsString()
  standardLongLabel: string;

  @AutoMap()
  @IsString()
  standardShortLabel: string;

  @AutoMap()
  @IsString()
  daylightLongLabel: string;

  @AutoMap()
  @IsString()
  daylightShortLabel: string;

  @AutoMap()
  @IsString()
  displaySeq: string;

  @AutoMap()
  @IsString()
  timezoneName: string;
}
